import { useAtomValue } from 'jotai';
import { useRouter } from 'next/router';

import { ownershipAtom } from '../stores/ownershipAtom';
import { getNavScreen, OWNERSHIP_LIST_HREF } from '../utils/navPath';

/** 길이 없을 때 따를 소유 기준. 화면 고정 메뉴가 있으면 그걸, 없으면 화면이 알린 값을 쓴다. 모르면 `null`. */
export function useResolvedOwnership(): boolean | null {
  const { pathname } = useRouter();
  const declared = useAtomValue(ownershipAtom);
  const fixedMenu = getNavScreen(pathname)?.fallbackMenu;
  if (fixedMenu) return fixedMenu === OWNERSHIP_LIST_HREF.mine;
  return declared?.isMine ?? null;
}
